const ranks = [{
	id: 0,
	name: 'Beginner',
	pointsMin: 0,
	pointsMax: 2499.99,
	point_coefficient: 1

},
{
	id: 1,
	name: 'Bronze',
	pointsMin: 2500,
	pointsMax: 7499.99,
	point_coefficient: 1.1

}, {
	id: 2,
	name: 'Silver',
	pointsMin: 7500,
	pointsMax: 24999.99,
	point_coefficient: 1.2

}, {
	id: 3,
	name: 'Gold',
	pointsMin: 25000,
	pointsMax: 49999.99,
	point_coefficient: 1.3

}, {
	id: 4,
	name: 'Diamond',
	pointsMin: 50000,
	pointsMax: 499999.99,
	point_coefficient: 1.4

}, {
	id: 5,
	name: 'Black member',
	pointsMin: 500000,
	pointsMax: 10000000000,
	point_coefficient: 1.5
}];

const locale = {
	ru: ranks,
	uk: ranks,
	en: ranks,
	de: ranks,
	vi: ranks,
	th: ranks
};

module.exports = {
	enum: ranks,
	locale: locale,
	ranks: {
		beginner: 0,
		bronze: 1,
		silver: 2,
		gold: 3,
		diamond: 4,
		black_member: 5
	}
};



// WEBPACK FOOTER //
// ./enums/affiliate-ranks.js